import {AxiosResponse} from "axios";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {ITeamResponse} from "data/providers/api/team.api.provider";

export interface IMakeTradePayload {
	gamedayId: number;
	captainId: number;
	trades: ITradeObj[];
}

export interface ITradeObj {
	playerOut: number;
	playerIn: number;
}

export interface IRollbackTradePayload {
	gamedayId: number;
}

export type TTeamResponse = IApiResponse<{team: ITeamResponse}>;

export interface ITradeApiProvider {
	make: (params: IMakeTradePayload) => Promise<AxiosResponse<TTeamResponse>>;
	rollback: (params: IRollbackTradePayload) => Promise<AxiosResponse<TTeamResponse>>;
}

@injectable()
export class TradeApiProvider implements ITradeApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	make = (params: IMakeTradePayload) =>
		this._http.post<TTeamResponse>("fantasy/trade/make", params);
	rollback = (params: IRollbackTradePayload) =>
		this._http.post<TTeamResponse>("fantasy/trade/rollback", params);
}
